import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import PaymentTable from './PaymentTable';


const Payment = () => {
 
  const [paymentdata, setpaymentdata] = useState([]);
  const [showmodal, setshowmodal] = useState(false);

  const fetchdata = async () => {
    try {
      let mdata = await getdata({filter:{datatype:"paymentdata"}});
      setpaymentdata(mdata.reverse());
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchdata(); }, []);

  return (
    <div className="content-area">

      <PaymentTable 
        paymentdata={paymentdata}
        />
    
    </div>
  );
};

export default Payment;